module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-16x9-52809e657c39397f7904c5148ed13b81.jpg";